/* SAJUST size animation — viewport-anchored pill, horizontal motion only.
   Do not append absolute children to <fieldset>; its legend geometry causes
   the detour below the row in some browsers. */
(() => {
  if (window.sajustSizeMotionLoaded) return;
  window.sajustSizeMotionLoaded = true;

  const previous = new WeakMap();
  const active = new WeakMap();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const selected = group => group?.querySelector('input[type="radio"]:checked + label');
  const prime = () => document.querySelectorAll('.sajust-size-picker').forEach(group => {
    if (!previous.has(group)) previous.set(group, selected(group));
  });

  function cleanup(group) {
    const item = active.get(group);
    active.delete(group);
    if (item) {
      item.animation?.cancel();
      item.element.remove();
    }
    group.querySelectorAll('.sajust-size-motion-from, .sajust-size-motion-to').forEach(label => {
      label.classList.remove('sajust-size-motion-from', 'sajust-size-motion-to');
    });
    group.classList.remove('sajust-size-animating');
  }

  document.addEventListener('change', event => {
    const radio = event.target;
    if (!radio.matches?.('.sajust-size-picker input[type="radio"]')) return;
    const group = radio.closest('.sajust-size-picker');
    const destination = selected(group);
    const origin = previous.get(group);
    previous.set(group, destination);
    cleanup(group);
    if (!origin || !destination || origin === destination || !origin.isConnected || reducedMotion.matches) return;

    const from = origin.getBoundingClientRect();
    const to = destination.getBoundingClientRect();
    if (!from.width || !to.width || Math.abs(from.top - to.top) > 4) return;

    // A fixed overlay is immune to fieldset, legend, flex and variant redraw layout.
    // Both endpoints use the same Y coordinate throughout the animation.
    const pill = document.createElement('span');
    pill.setAttribute('aria-hidden', 'true');
    const sourceText = document.createElement('span');
    const targetText = document.createElement('span');
    // Use variant values, not label.textContent (which also contains screen-reader-only sold-out messages).
    sourceText.textContent = origin.previousElementSibling?.value || origin.textContent.trim();
    targetText.textContent = destination.previousElementSibling?.value || destination.textContent.trim();

    const commonText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;white-space:nowrap;font:inherit;color:#fff;';
    sourceText.style.cssText = commonText;
    targetText.style.cssText = commonText + 'opacity:0;';
    pill.append(sourceText, targetText);

    const radius = getComputedStyle(destination).borderRadius || '999px';
    const typography = getComputedStyle(destination);
    pill.style.cssText = [
      'position:fixed', 'pointer-events:none','z-index:2147483000',
      'left:'+from.left+'px', 'top:'+from.top+'px',
      'width:'+from.width+'px','height:'+from.height+'px',
      'border-radius:'+radius,'background:#121212','overflow:hidden',
      'font-family:'+typography.fontFamily,'font-size:'+typography.fontSize,
      'font-weight:'+typography.fontWeight,'line-height:'+typography.lineHeight,
      'box-sizing:border-box','will-change:left,width'
    ].join(';');
    document.body.appendChild(pill);
    group.classList.add('sajust-size-animating');
    origin.classList.add('sajust-size-motion-from');
    destination.classList.add('sajust-size-motion-to');

    const dx = to.left - from.left;
    const midWidth = Math.max(from.width, to.width) + Math.min(13, Math.abs(dx) * 0.07);
    // Only left/width change; top is constant. No translateY, no detour.
    const animation = pill.animate([
      { left:from.left+'px', width:from.width+'px', offset:0 },
      { left:(from.left+dx*0.5)+'px', width:midWidth+'px', offset:0.5 },
      { left:to.left+'px', width:to.width+'px', offset:1 }
    ], { duration:310, easing:'cubic-bezier(.22,1,.36,1)' });

    sourceText.animate([
      {opacity:1,offset:0},{opacity:1,offset:0.35},
      {opacity:0,offset:0.53},{opacity:0,offset:1}
    ], {duration:310,fill:'forwards'});
    targetText.animate([
      {opacity:0,offset:0},{opacity:0,offset:0.42},
      {opacity:1,offset:0.60},{opacity:1,offset:1}
    ], {duration:310,fill:'forwards'});

    const item = {element:pill,animation};
    active.set(group,item);
    animation.finished.then(() => {
      if (active.get(group) === item) cleanup(group);
    }).catch(() => {});
  }, true);

  ['pointerdown','keydown'].forEach(name => document.addEventListener(name,event => {
    const group = event.target.closest?.('.sajust-size-picker');
    if (group) previous.set(group, selected(group));
  }, true));

  new MutationObserver(mutations => {
    if (mutations.some(m => Array.from(m.addedNodes).some(node => node.nodeType === 1 &&
      (node.matches?.('.sajust-size-picker, variant-selects') || node.querySelector?.('.sajust-size-picker'))))) prime();
  }).observe(document.documentElement,{childList:true,subtree:true});

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',prime,{once:true});
  else prime();
})();
